<template>
  <div v-if="isOpen" class="modal-wrapper">
    <div
      class="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-neutral-700 bg-opacity-55"
    >
      <div :class="{
        'p-4 w-full h-full': noButtons,
        'max-w-md w-full h-full flex items-center justify-center': !noButtons,
      }">
      <div
        class="w-full mx-auto bg-white border border-solid rounded-lg shadow-lg select-none border-neutral-300"
        :class="{
          'max-w-md': !noButtons,
        }"
      >
        <div
          class="flex items-center justify-between p-4 bg-white border-b border-solid rounded-t-lg border-neutral-300"
        >
          <!-- Modal title -->
          <h3 class="text-lg font-semibold text-neutral-800">
            {{ title }}
          </h3>
          <!-- Close button for noButtons mode -->
          <button
              v-if="noButtons"
            @click="emit('close')"
            class="flex items-center justify-center p-2 -m-2 text-sm border-none rounded-lg w-[40px] h-[40px] bg-neutral-100 text-neutral-800 hover:bg-red-700 hover:text-white"
            >
            <X :size="20" />
          </button>
        </div>
        <div class="p-4">
          <!-- Modal content slot -->
          <div class="space-y-4">
            <slot></slot>
          </div>
          <!-- Action buttons -->
          <div class="flex justify-end mt-6 space-x-2" v-if="!noButtons">
            <button
              @click="closeModal"
              class="w-24 px-3.5 py-2.5 bg-neutral-100 text-neutral-800 text-center rounded-lg text-sm font-medium hover:bg-neutral-200"
              type="button"
            >
              Annuller
            </button>
            <button
              @click="submitModal"
              class="w-24 text-white disabled:cursor-progress disabled:opacity-50 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              :class="{
                'bg-green-600 hover:bg-green-700': isConfirm,
                'bg-red-700 hover:bg-red-800': !isConfirm,
              }"
              type="submit"
              :disabled="isLoading"
            >
              {{ isConfirm ? (isLoading ? "Gemmer..." : "Bekræft") : "Slet" }}
            </button>
          </div>
        </div>
      </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, inject } from "vue";
import { storeToRefs } from "pinia";
import { X } from "lucide-vue-next";

// Inject events store
const eventsStore = inject("eventsStore");
const { isLoading } = storeToRefs(eventsStore);

// Define props
defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
  isConfirm: {
    type: Boolean,
    default: false,
  },
  noButtons: {
    type: Boolean,
    default: false,
  },
});

// Define emits
const emit = defineEmits(["close", "submit"]);

// Method to close the modal
const closeModal = () => {
  emit("close");
};

// Method to submit the modal
const submitModal = () => {
  const formData = collectFormData();
  emit("submit", formData);
};

// Method to collect form data
const collectFormData = () => {
  const inputs = document.querySelectorAll(
    ".reusable-modal input, .reusable-modal select, .reusable-modal textarea"
  );
  const formData = {};

  inputs.forEach((input) => {
    if (input.name) {
      formData[input.name] = input.value;
    }
  });

  return formData;
};
</script>

<style>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}
</style>